import styled from 'styled-components';
import Button from 'components/Core/Button';

const Container = styled.div`
  .section-layout--container {
    padding: 0 20px;
  }

  .in-page-features-v3--inner-container {
    padding: 15px 20px 50px;
  }

  .in-page-features-v3--featured-content-heading {
    display: none;
  }

  .in-page-features-v3--featured-content-description {
    text-align: left;
    font-size: var(--font-size-20);
    font-weight: var(--font-weight-400);
    margin: 0;
  }

  a.button--atag {
    border-radius: 0px !important;
  }

  @media (max-width: 767px) {
    .in-page-features-v3--inner-container {
      padding: 15px 0 30px;
    }
  }
`;

const StyledTitle = styled.h2`
  padding: 75px 0 20px 0;
  margin: 0;
  text-align: center;

  @media (max-width: 575px) {
    padding: 75px 28px 0 28px;
  }
`;

const StyledButton = styled(Button)`
  box-shadow: none;
  padding: var(--button-padding);
  width: 100%;
  margin-top: 30px;

  p {
    color: var(--white);
    font-family: var(--font-family);
    font-size: var(--font-size-20);
    font-weight: var(--font-weight-800);
    line-height: var(--line-height-110);
    letter-spacing: var(--letter-spacing--0-02);
    margin: 0;
  }
`;

const FeaturedContentInnerContainer = styled.div`
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 767px) {
    min-height: 300px;
  }
`;

export { Container, StyledTitle, StyledButton, FeaturedContentInnerContainer };
